import { render, staticRenderFns } from "./Truncate.vue?vue&type=template&id=aa526cb8&"
import script from "./Truncate.vue?vue&type=script&lang=ts&"
export * from "./Truncate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports